import { render, staticRenderFns } from "./remoteImg.vue?vue&type=template&id=1510ae09&scoped=true&"
import script from "./remoteImg.vue?vue&type=script&lang=js&"
export * from "./remoteImg.vue?vue&type=script&lang=js&"
import style0 from "./remoteImg.vue?vue&type=style&index=0&id=1510ae09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1510ae09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1510ae09')) {
      api.createRecord('1510ae09', component.options)
    } else {
      api.reload('1510ae09', component.options)
    }
    module.hot.accept("./remoteImg.vue?vue&type=template&id=1510ae09&scoped=true&", function () {
      api.rerender('1510ae09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/remoteImg.vue"
export default component.exports